"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhantomAdapter = void 0;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const phantom_1 = require("./phantom");
class PhantomAdapter {
    constructor(keyring) {
        this.keyring = keyring;
    }
    static useKeyring(keyring) {
        return new PhantomAdapter(keyring);
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            return Object.keys(this.keyring.wallets).length;
        });
    }
    pairDevice() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const evmProvider = (_a = window.phantom) === null || _a === void 0 ? void 0 : _a.ethereum;
            const bitcoinProvider = (_b = window.phantom) === null || _b === void 0 ? void 0 : _b.bitcoin;
            const solanaProvider = (_c = window.phantom) === null || _c === void 0 ? void 0 : _c.solana;
            if (!evmProvider || !bitcoinProvider || !solanaProvider) {
                window.open("https://phantom.app/", "_blank");
                console.error("Please install Phantom!");
                throw new Error("Phantom provider not found");
            }
            // Assume Solana accounts are always present
            // Note, we don't try and get EVM accounts below just yet - we only use the Solana account as a deviceID
            yield solanaProvider.connect();
            const wallet = new phantom_1.PhantomHDWallet(evmProvider, bitcoinProvider, solanaProvider);
            yield wallet.initialize();
            const deviceID = yield wallet.getDeviceID();
            this.keyring.add(wallet, deviceID);
            this.keyring.emit(["Phantom", deviceID, core.Events.CONNECT], deviceID);
            return wallet;
        });
    }
}
exports.PhantomAdapter = PhantomAdapter;
//# sourceMappingURL=adapter.js.map